import type { UsageSnapshot } from '@/lib/baba-api'

export function publishUsageSnapshot(
  u: UsageSnapshot,
  setUsage: (value: UsageSnapshot) => void,
): void {
  setUsage(u)
  try {
    localStorage.setItem('baba.app.last_usage', JSON.stringify(u))
  } catch {}
  try {
    window.dispatchEvent(new CustomEvent('baba:usage-updated', { detail: u }))
  } catch {}
}
